import { User } from "@/types/users";

export const OrganizationHelper = {
  getOrganizationName: (user: User | undefined) => {
    if (!user) {
      return ''
    } else if (user.currentOrganization?.name) {
      return user.currentOrganization.name
    } else if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`
    }
    return ''
  }
}
